// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"31": "ffdc634d","639": "4374c962","6499": "9ccdb6ef","6500": "32a72beb","6545": "804a81ef","8436": "c18f29d4",}[chunkId] + ".css"
}